import React from 'react'
import Header from '../components/Header'

const index = () => {
  return (
    <div>
      <Header />
    </div>
  )
}

export default index
